import { render } from "./CreateOrder.vue?vue&type=template&id=5be5c7de&scoped=true&ts=true"
import script from "./CreateOrder.vue?vue&type=script&lang=ts"
export * from "./CreateOrder.vue?vue&type=script&lang=ts"

import "./CreateOrder.vue?vue&type=style&index=0&id=5be5c7de&lang=scss&scoped=true"

import exportComponent from "/Users/tobias/Projects/MontyBuy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be5c7de"]])

export default __exports__